import React from "react";
import Text from "../../../../styleguide/Text";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch } from "../../../../redux/hooks";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import { getDownloadReturningReport } from "../../../../redux/api/reports.api";

function ReturningTasksHeader() {
  const dispatch = useAppDispatch();
  const { tableData, tableSearch, tablePagination } = useTableCtx() || {};

  const exportRaport = async () => {
    await dispatch(
      getDownloadReturningReport({
        page: tablePagination?.page,
        perPage: tablePagination?.rowsPerPage,
        status: tableSearch?.status,
        deliveryPoint: tableSearch?.deliveryPoint,
      }),
    );
  };

  return (
    <div className="flex justify-between mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900 mb-4"
        gutterBottom>
        Retur de la client
      </Text>
      {tableData && tableData?.length > 0 && (
        <CustomButton
          variant="contained"
          withConfirmationModal={{
            modalTitle: "Exporta raport",
            modalSubtitle: "Esti sigur ca vrei sa exporti raportul?",
            modalLeftButtonText: "Anuleaza",
            modalLeftButtonVariant: "outlined",
            modalRightButtonText: "Exporta",
            modalRightButtonOnClick: exportRaport,
          }}>
          Exporta raport
        </CustomButton>
      )}
    </div>
  );
}

export default ReturningTasksHeader;
